module.exports = __webpack_public_path__ + "static/avatar_4-dc8c505a9c44838e070a92feb9060a0d.png";